import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

function extractSessionId() {
  const hash = window.location.hash || "";
  const search = window.location.search || "";
  if (hash.includes("session_id=")) {
    return new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
  }
  if (search.includes("session_id=")) {
    return new URLSearchParams(search).get("session_id");
  }
  return null;
}

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = extractSessionId();
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        window.history.replaceState(null, "", window.location.pathname);
        await checkAuth();
        navigate(data.needs_role ? "/choose-role" : "/feed", { replace: true });
      } catch (e) {
        setError("Google sign-in failed. Redirecting you back to login…");
        setTimeout(() => navigate("/login", { replace: true }), 2200);
      }
    })();
  }, [navigate, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]" data-testid="auth-callback-page">
      <div className="text-center">
        {error ? (
          <p className="text-sm text-red-600" data-testid="auth-callback-error">{error}</p>
        ) : (
          <>
            <div className="w-8 h-8 border-2 border-[#074572] border-t-transparent rounded-full animate-spin mx-auto" />
            <p className="mt-4 text-sm text-zinc-500">Signing you in…</p>
          </>
        )}
      </div>
    </div>
  );
}
